import { useEffect, useState } from "react";
import { WalletCard } from "./WalletCard";
import { To } from "react-router-dom";
import groupsvg from "../../assets/dashboard/Group.svg";
import NavCard from "./NavCard";
import { useAuth } from "context/auth-context";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "react-loading-overlay-ts";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { FiCheckCircle } from "react-icons/fi";
import { GetBonusPointDetailsApi, getPointBalanceStudiesWiseApi } from "../Dashboard/Dasboard.api";
import BonusPopUp from "../../components/BonusPop copy";
import { Shistory } from "./Shistory";
import { JoinQualificationpopup } from "components/JoinNowForm/JoinQualificationPopup";
import AffiliateOffers from "components/Affiliate/AffiliateOffers";
import { Card, PageHeader } from "components/ui";

function Dashboard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showJoinQualification, setShowJoinQualification] = useState(false);
  const [showModal, setShowModal] = useState(!!localStorage.getItem("bonusPopup"));
  const [showAffiliateOffers, setShowAffiliateOffers] = useState(false);
  const navigationto = (url: To) => {
    navigate(url);
  };

  const { auth } = useAuth();
  const [searchParams] = useSearchParams();
  const affiliateOfferId = Array.from(searchParams.keys())[0] || "";
  const isAffiliatedUser = Boolean(affiliateOfferId);
  const GetBonusPointDetails = useQuery(
    ["getBonusPointDetails", auth.panelistId, showJoinQualification],
    () => GetBonusPointDetailsApi(auth.panelistId, isAffiliatedUser, affiliateOfferId),
    {
      refetchOnWindowFocus: false,
    }
  );
  const getPointsBalance = useQuery(["pointBal", auth.panelistId], () => getPointBalanceStudiesWiseApi(auth.panelistId), {
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (GetBonusPointDetails.isSuccess) {
      if (GetBonusPointDetails?.data?.qual_popup_shown === 0 && localStorage.getItem("joinQualPopup")) {
        setShowJoinQualification(true);
      } else {
        setShowJoinQualification(false);
      }
    }
  }, [GetBonusPointDetails.isSuccess, showJoinQualification]);

  useEffect(() => {
    if (GetBonusPointDetails.isSuccess) {
      if (GetBonusPointDetails?.data?.max_bounty_offers === 1) {
        if (GetBonusPointDetails?.data?.max_bounty_user.includes(String(auth.panelistId))) {
          setShowAffiliateOffers(true);
        } else {
          setShowAffiliateOffers(false);
        }
      } else if (GetBonusPointDetails?.data?.max_bounty_offers === 2) {
        setShowAffiliateOffers(true);
      } else {
        setShowAffiliateOffers(false);
      }
    }
  }, [GetBonusPointDetails.isSuccess]);

  const pointBalance = getPointsBalance && getPointsBalance?.data ? getPointsBalance?.data?.data : 0;

  const BonusData =
    GetBonusPointDetails &&
    GetBonusPointDetails?.data &&
    GetBonusPointDetails?.data?.data &&
    GetBonusPointDetails?.data?.data[0] &&
    GetBonusPointDetails?.data?.data[0]?.userId;
  const BonusUserPoint =
    GetBonusPointDetails &&
    GetBonusPointDetails?.data &&
    GetBonusPointDetails?.data?.SelectBounusData &&
    GetBonusPointDetails?.data?.SelectBounusData;

  const guidelines = [
    t("reward.eligibility.dashboard"),
    t("dashboard.reward.verification"),
    t("dashboard.reward.distribution"),
    t("dashboard.reward.support"),
  ];

  const closepopup = () => {
    localStorage.removeItem("joinQualPopup");
    localStorage.setItem("bonusPopup", "true");
    setShowJoinQualification(false);
    setShowModal(true);
  };

  const firstName = auth?.name ? auth.name.split(" ")[0] : "";

  return (
    <LoadingOverlay
      styles={{
        overlay: (base) => ({
          ...base,
          position: "fixed",
          background: "rgb(var(--zs-overlay) / 0.45)",
        }),
      }}
      active={GetBonusPointDetails.isLoading}
      spinner
      text={t("page.Loading")}
    >
      {showJoinQualification && <JoinQualificationpopup closepopup={closepopup} email={auth?.email} />}
      {BonusData == 0 && BonusUserPoint == 1 && showModal ? <BonusPopUp /> : null}

      <div className="zs-page">
        <PageHeader
          eyebrow={t("side.bar.Dashboard")}
          title={firstName ? `Welcome back, ${firstName}` : t("side.bar.Dashboard")}
          subtitle="Your points, reward progress and survey activity at a glance."
        />

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
          <WalletCard
            groupsvg={groupsvg}
            points={+pointBalance ? +pointBalance : 0}
            pointBalance={t("dashboard.points.Balance")}
            redeem={`View Details`}
            onselect={() => navigationto("/survey-redeem")}
          />
          <div className="lg:col-span-2">
            <NavCard />
          </div>
        </div>

        {showAffiliateOffers && (
          <div className="mt-4">
            <AffiliateOffers />
          </div>
        )}

        <div className="grid grid-cols-1 gap-4 mt-4 xl:grid-cols-3">
          <div className="min-w-0 xl:col-span-2">
            <Shistory />
          </div>

          <Card title={t("dashboard.reward.Text")} className="h-fit">
            <ul className="flex flex-col gap-3">
              {guidelines.map((text, index) => {
                const [heading, detail] = text.split(": ");
                return (
                  <li key={index} className="flex gap-3">
                    <FiCheckCircle className="w-4 h-4 mt-0.5 shrink-0 text-success" />
                    <p className="text-sm leading-relaxed text-ink-2">
                      <span className="font-semibold text-ink">{heading}</span>
                      {detail !== undefined && <>: {detail}</>}
                    </p>
                  </li>
                );
              })}
            </ul>
            <p className="pt-4 mt-4 text-sm font-medium border-t border-line text-ink-3">{t("dashboard.reward.Thanks")}</p>
          </Card>
        </div>
      </div>
    </LoadingOverlay>
  );
}
export default Dashboard;
